import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { translations } from '../data/translations';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_4a49ee36-674e-4876-bdde-a21aaf32773b/artifacts/4ka36pr5_Logo%20Samanext%20Transparente.png';

const Header = ({ lang, setLang }) => {
  const t = translations[lang].nav;
  const location = useLocation();
  const isEqtosPage = location.pathname === '/eqtos';
  
  const toggleLang = () => {
    setLang(lang === 'en' ? 'es' : 'en');
  };

  // Don't show header on EQTOS page (it has its own nav)
  if (isEqtosPage) return null;
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/25">
      <div className="max-w-7xl mx-auto px-6 lg:px-16 h-20 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center hover:opacity-80 transition-opacity duration-300">
          <img 
            src={LOGO_URL} 
            alt="Samanext Technologies" 
            className="h-10 md:h-12 w-auto"
          />
        </Link>
        
        {/* Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <a
            href="#about"
            className="text-[#4D4D4D] text-lg font-normal hover:text-white transition-colors duration-300"
          >
            {t.about}
          </a>
          <a
            href="#vision"
            className="text-[#4D4D4D] text-lg font-normal hover:text-white transition-colors duration-300"
          >
            {t.vision}
          </a>
          <Link
            to="/eqtos"
            className="text-[#00FFD1] text-lg font-semibold hover:text-[#00FFD1]/80 transition-colors duration-300"
          >
            EQTOS
          </Link>
          <a
            href="#contact"
            className="text-[#4D4D4D] text-lg font-normal hover:text-white transition-colors duration-300"
          >
            {t.contact}
          </a>
        </nav>
        
        {/* Right side actions */}
        <div className="flex items-center gap-4">
          {/* Language Toggle */}
          <button
            onClick={toggleLang}
            className="flex items-center gap-1 px-3 py-2 text-sm font-medium border border-white/25 hover:border-[#00FFD1] hover:text-[#00FFD1] transition-all duration-300"
          >
            <span className={lang === 'en' ? 'text-[#00FFD1]' : 'text-white/60'}>EN</span>
            <span className="text-white/40">|</span>
            <span className={lang === 'es' ? 'text-[#00FFD1]' : 'text-white/60'}>ES</span>
          </button>
          
          {/* CTA Button */}
          <Link
            to="/eqtos"
            className="hidden md:inline-flex items-center justify-center bg-[#00FFD1] text-black px-6 py-3 text-base font-medium hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] transition-all duration-400 ease-in-out"
          >
            {t.viewPortfolio}
          </Link>
        </div>
        
        {/* Mobile Menu Button */}
        <button className="md:hidden text-white p-2 ml-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="3" y1="12" x2="21" y2="12"></line>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <line x1="3" y1="18" x2="21" y2="18"></line>
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Header;
